import React, { useEffect } from "react"
import styled from "styled-components"
import { useInView } from 'react-intersection-observer';

import { H2, P, Sub } from "components/Typography"
import Video from "./Video"

const BackgroundContainer = ({ children, subtitle, title, text, video, setSelectedNavItem, mobileTitle }) => {
	const { ref, inView } = useInView({
		threshold: 0,
	});

	useEffect(() => {
		if (inView && setSelectedNavItem) {
			setSelectedNavItem(subtitle.toLowerCase())
		}
	}, [inView, setSelectedNavItem, subtitle])

	return (
		<Section id={"play-" + subtitle.toLowerCase()}>
			<SelectedStateCheck ref={ref} />

			<img className="ornament" src='/images/how-to-play/ornament.png' alt="" />
			<header>

				{subtitle && <Sub style={{ textTransform: "uppercase" }}>{subtitle}</Sub>}
				{title &&
					<>
						<div className="desktop-title"><H2 size="2.2rem" color="white" style={{ marginBottom: 0 }}>{title}</H2>
						</div>
						<div className="mobile-title">
							<H2 size="2.2rem" color="white" style={{ marginBottom: 0 }}>
								{mobileTitle ? <span dangerouslySetInnerHTML={{ __html: mobileTitle }} /> : title}
							</H2>
						</div>
					</>
				}

				{text && <P style={{ marginBottom: "0.25rem", marginTop: "0.64rem" }}>{text}</P>}
			</header>

			{children}

			{video && <VideoContainer><Video {...video} /></VideoContainer>}
		</Section>
	)
}

export default BackgroundContainer


const SelectedStateCheck = styled.div`
	position: absolute;
	height: 150px;
	width: 100%;
	pointer-events: none;
	top: 150px;

	@media (max-width: 750px) {
		display: none;
	}
`

const Section = styled.section`
position: relative;
	width: 100%;
	background-color: var(--bgLight);
	border: 1px solid var(--darkBorder);
	margin-bottom: 6rem;
	position: relative;

	.ornament {
		position: absolute;
		top:-56px;
		height: 90px;
		left: 50%;
		pointer-events: none;
		 transform: translateX(-50%);
	}

	header {
		padding: 2rem;
		padding-right: 3rem;
	}

	.mobile-title {
		display: none;
	}


	@media (max-width: 750px) { 
		border-left: 0px;
		border-right: 0px;
		margin-bottom: 4rem;


		header {
		}
	}

	@media (max-width: 600px) {
		.mobile-title {display:block}
		.desktop-title {display: none;}
	}
`

const VideoContainer = styled.div`
	padding: 8px;
	background-color: #0C061E;
	border-top: 1px solid var(--darkBorder);
	width: 100%;
`